// Печат само на документа на отчета (личен / на заведението): изваждаме
// .report-doc-paper в <body>, маркираме body с .printing-report (CSS скрива
// всичко останало), печатаме и връщаме node-а на мястото му. Същият подход
// като при фактурата (InvoicePreviewModal) и складовите документи
// (DeliveryDocumentModal и др.) — чист window.print() печата ЦЯЛАТА страница,
// защото antd Modal е портал върху нея.
export const printReportDocument = () => {
  const paper = document.querySelector(
    ".report-doc-paper",
  ) as HTMLElement | null;
  if (!paper || !paper.parentElement) {
    window.print();
    return;
  }
  const parent = paper.parentElement;
  const placeholder = document.createComment("report-doc-placeholder");
  parent.insertBefore(placeholder, paper);
  document.body.appendChild(paper);
  document.body.classList.add("printing-report");
  const restore = () => {
    document.body.classList.remove("printing-report");
    if (placeholder.parentElement) parent.insertBefore(paper, placeholder);
    placeholder.remove();
    window.removeEventListener("afterprint", restore);
  };
  window.addEventListener("afterprint", restore);
  requestAnimationFrame(() => window.print());
};

// Рендира се като <style>{reportPrintCss}</style> в модала на отчета.
// @page { margin: 0 } маха датата/заглавието на браузъра от разпечатката;
// overflow/max-height се развързват, за да се отпечата целият отчет, а не
// само видимата в скрола част.
export const reportPrintCss = `
  @page { size: A4; margin: 0; }
  @media print {
    body.printing-report > *:not(.report-doc-paper) { display: none !important; }
    body.printing-report { background: #fff !important; }
    body.printing-report .report-doc-paper {
      display: block !important;
      position: static !important;
      max-height: none !important;
      overflow: visible !important;
      box-shadow: none !important;
      padding: 14mm 12mm !important;
    }
  }
`;
